import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim grounded — see GROUNDING NOTE in metadata.md for file/migration mapping.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "Same PDF. NotebookLM gave a detailed, cited answer. My RAG said: “no specific predictions in the sources.”" },
];

export const GAP: ScriptLine[] = [
  { scene: "gap", fromSec: 0.4, holdSec: 5.5, caption: "NotebookLM doesn’t do better RAG — it skips RAG. It pours the whole 373-page document into a 1M-token window." },
  { scene: "gap", fromSec: 6.2, holdSec: 6, caption: "Mine retrieved top-K chunks. For a 200-chunk doc, the model saw ~7% of it." },
  { scene: "gap", fromSec: 12.5, holdSec: 5.5, caption: "And it retrieved a table-of-contents page with the right dates — but zero predictions." },
];

export const NOTYET: ScriptLine[] = [
  { scene: "notyet", fromSec: 0.4, holdSec: 5, caption: "The obvious fix is to copy them: long-context bypass and HyDE. I scoped both — and shipped neither." },
  { scene: "notyet", fromSec: 5.6, holdSec: 4.8, caption: "They’re on the roadmap, not in the repo. So I fixed what I could verify instead." },
];

export const FIXES: ScriptLine[] = [
  { scene: "fixes", fromSec: 0.4, holdSec: 5.5, caption: "Three concrete fixes closed most of the gap — none of them needed a million-token model." },
  { scene: "fixes", fromSec: 6.2, holdSec: 5, caption: "A decision-tree synthesis prompt, a recency primitive, and a citation panel." },
  { scene: "fixes", fromSec: 11.5, holdSec: 5, caption: "Plus the BM25 fix from the last video — migrations 033 and 034." },
];

export const PROMPT: ScriptLine[] = [
  { scene: "prompt", fromSec: 0.5, holdSec: 6, caption: "The model kept saying “not available” when the answer WAS in the sources, just worded differently." },
  { scene: "prompt", fromSec: 7, holdSec: 6.5, caption: "So the synthesis prompt is a literal decision tree: same topic → answer; partial → answer the covered part." },
  { scene: "prompt", fromSec: 14, holdSec: 5.5, caption: "Only a completely different domain earns “not available” — the prompt says that should be under 1% of queries." },
];

export const RECENCY: ScriptLine[] = [
  { scene: "recency", fromSec: 0.4, holdSec: 6, caption: "Embeddings rank by meaning, not by date — so “what shipped this week?” surfaced a stale helper over a fresh feature." },
  { scene: "recency", fromSec: 6.6, holdSec: 6, caption: "I added list_recent_docs — a recency primitive that orders by created_at, not cosine distance." },
  { scene: "recency", fromSec: 12.8, holdSec: 5, caption: "And a black-box eval probe that fails when a stale doc out-ranks a fresh one." },
];

export const CITATION: ScriptLine[] = [
  { scene: "citation", fromSec: 0.4, holdSec: 5.5, caption: "NotebookLM’s trust trick: every claim is a clickable citation. So I built the same." },
  { scene: "citation", fromSec: 6.2, holdSec: 5.5, caption: "Click any [Source N] and a panel opens the exact chunk it came from — no “trust me.”" },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 5.5, caption: "Code-query retrieval accuracy went from ~75% to a peak of 90% — on standard Postgres, no 1M context." },
  { scene: "payoff", fromSec: 6.2, holdSec: 6, caption: "The decision-tree prompt killed the false “not available.” Recency + citations closed the trust gap." },
  { scene: "payoff", fromSec: 12.5, holdSec: 5.5, caption: "NotebookLM still wins on long single docs. For a multi-source code KB, this is the shape that works." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "You don’t beat NotebookLM by copying its architecture — you fix the parts of yours you can actually measure." },
  { scene: "outro", fromSec: 6, holdSec: 4, caption: "Next: RRF, CRAG, and why I embed in 1536 dimensions." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
